import { combineReducers } from "redux";
import role  from "./role";
/*interface IRootState {
  role: IRoleState;
}*/
export default combineReducers<any>({
  role,
});
